import {
  AbstractControl,
  AsyncValidatorFn,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { of, Observable } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PatientsService } from '../../core/services/patient/patients.service';

@Injectable({ providedIn: 'root' })
export class EmailValidatorService {
  constructor(
    private http: HttpClient,
    private patientsService: PatientsService,
  ) {}

  validEmailFormat(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const email = control.value;
      if (!email) {
        return null;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(email)) {
        return { email: true };
      }

      return null;
    };
  }

  checkEmail(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      const parent = control.parent;
      if (!parent) {
        return of(null);
      }

      const name = parent.get('name')?.value;
      const lastName = parent.get('lastName')?.value;
      const email = control.value;
      if (!name || !lastName || !email) {
        return of(null);
      }
      return of(null);
    };
  }
}
